import React from 'react';
import {PowerListCards} from '../';
import {DropContainer, DropIcon, DropTitle} from './styles';

export default ({
  theme,
  dataCy,
  mHeigth,
  onClick,
  firstActve,
  primaryTitle,
  dataArray = [],
  mWidth = 'auto',
  mPadding = '10px 0 10px 10px',
}: {
  onClick: any;
  theme?: string;
  mWidth?: string;
  dataCy?: string;
  mHeigth?: string;
  mPadding?: string;
  firstActve?: boolean;
  primaryTitle?: string;
  dataArray?: Array<any>;
}) => (
  <DropContainer mWidth={mWidth} mPadding={mPadding} data-cy={dataCy}>
    <DropTitle theme={theme} firstActve={firstActve}>
      {primaryTitle}
    </DropTitle>

    <DropIcon theme={theme} />

    <PowerListCards data={dataArray} onClick={onClick} mHeigth={mHeigth} />
  </DropContainer>
);
